import { getFormValues } from 'redux-form';
import { FORM_MODEL } from 'admin/constants/common';

export const createStoryFormValuesSelector = getFormValues(FORM_MODEL.CREATE_STORY);
